interface EnvConfig {
  baseUrl: string;
  flagshopApiUrl: string;
  s3BaseUrl: string;
  ggMapAPIKey: string;
  devEnv: string;
}

const env: EnvConfig = {
  baseUrl: import.meta.env.VITE_BASE_URL,
  flagshopApiUrl: import.meta.env.VITE_FLAGSHOP_BASE_URL,
  s3BaseUrl: import.meta.env.VITE_AWS_S3_BASE_URL,
  ggMapAPIKey: import.meta.env.VITE_GG_MAP_API_KEY,
  devEnv: import.meta.env.VITE_DEV_ENV,
};

export default env;
